<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-container>
        <b-card header="Jitsi Conferenes" v-bind:class="[{ busy: busy}, 'opacity-transition']">
            <pb-spinner v-if="busy"></pb-spinner>
            <b-pagination class="float-left mb-2"
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          aria-controls="conference-table"
            ></b-pagination>
            <b-form inline class="float-right mb-2">
                <b-input-group>
                    <b-form-input size="md" v-debounce:400ms="(val, e) => filterString = val"  :value="filterString"
                                  placeholder="Search"
                                  class="mb-2 mr-sm-2 mb-sm-0"/>
                </b-input-group>
                <b-button v-b-modal.conferenceEditModal @click="conferenceToEdit = conferenceObj">
                    New Conference
                </b-button>
            </b-form>
            <b-table responsive striped hover small :items="conferenceList"
                     sortable
                     :filter-function="filterFunc"
                     :current-page="currentPage"
                     :per-page="perPage"
                     :filter="filterString"
                     :fields="['id', 'validFrom', 'validTo','jitsiRoom','userList','action']"
                     @filtered="onFiltered">
                <template v-slot:cell(validFrom)="row">
                    {{row.item.validFrom | moment("YYYY.MM.DD hh:mm") }}
                </template>
                <template v-slot:cell(validTo)="row">
                    {{row.item.validTo | moment("YYYY.MM.DD hh:mm") }}
                </template>
                <template v-slot:cell(userList)="row">
                    <div :key="key" v-for="(item, key) in row.item.userList">
                        <span>{{item.firstName}} {{item.lastName}}</span>
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <i v-b-modal.conferenceEditModal @click="conferenceToEdit = row.item" class="fal fa-edit"></i>
                    &nbsp;
                    <a role="button" @click="deleteItem(row.item.id)"><i class="fal fa-trash"></i></a>
                </template>
            </b-table>
            <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    aria-controls="conference-table"
            ></b-pagination>
        </b-card>
        <conference-edit-modal v-if="conferenceToEdit"
                               id="conferenceEditModal"
                               @success="load"
                               :conference="conferenceToEdit"
        />
    </b-container>
</template>

<script>
    import ConferenceEditModal from "../components/ConferenceEditModal";
    import ConferenceApi from "../../../shared/_api/conference";
    import {mapActions, mapState} from "vuex";

    export default {
        name: 'conference',
        components: {
            'conference-edit-modal': ConferenceEditModal
        },
        created() {
            if (!this.usersArray) {
                this.fetchUsers();
            }
        },
        data() {
            return {
                busy: false,
                filterString: '',
                currentPage: 1,
                perPage: 10,
                totalRows: 1,
                conferenceList: [],
                conferenceToEdit: this.conferenceObj
            }
        },
        mounted() {
            this.load();
        },
        computed: {
            ...mapState('usersManagement', ['usersArray']),
            conferenceObj() {
                return {
                    validFrom: new Date(),
                    validTo: new Date(),
                    user: {
                        id: null
                    },
                    jitsiRoom: null
                }
            },
            conferenceTableItems: function () {
                return this.conferenceList.map(item => {
                    return {
                        validFrom: this.parseLocalDateTime(item.validFrom),
                        validTo: this.parseLocalDateTime(item.validTo),
                    }
                })
            }
        },
        methods: {
            ...mapActions('usersManagement', ['fetchUsers']),
            load() {
                this.busy = true;
                ConferenceApi.all().then((conferenceList) => {
                    this.conferenceList = conferenceList.map(item => {
                        let validFrom = new Date(item.validFromDate),
                            validTo = new Date(item.validToDate),
                            rowVariant = validTo < new Date() ? 'inactive' : '';

                        return {
                            id: item.id,
                            userId: item.userId,
                            validFrom: validFrom,
                            validTo: validTo,
                            jitsiRoom: item.jitsiRoom,
                            userList: item.userList,
                            _rowVariant: rowVariant
                        }
                    });

                    this.conferenceList = this.$_.orderBy(this.conferenceList, ['_rowVariant', 'validFrom'], ['asc', 'asc']);

                    this.totalRows = this.conferenceList.length;
                }).finally(() => {
                    this.busy = false;
                })
            },
            filterFunc(userRow, filterProp) {
                if(!filterProp) {
                    return true;
                }

                let propArr = [],
                    searchString = filterProp.toLowerCase();

                if(userRow.userList && userRow.userList.length > 0) {
                    let userList = userRow.userList;
                    for(let i = 0; i < userList.length; i++) {
                        if (userList[i].firstName) {
                            propArr.push(userList[i].firstName.toLowerCase());
                        }

                        if (userList[i].lastName) {
                            propArr.push(userList[i].lastName.toLowerCase());
                        }
                    }
                }

                for(let i = 0; i < propArr.length; i++) {
                    if(propArr[i].indexOf(searchString) !== -1) {
                        return true;
                    }
                }

                return false;
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1
            },
            deleteItem(id) {
                ConferenceApi.delete(id);
            },
            resetConference() {
                return {
                    validFrom: null,
                    validTo: null,
                    userId: null,
                    jitsiRoom: null
                }
            }
        }

    }
</script>


<style lang="scss">
    .table-inactive {
        color: #adb5bd;
    }
</style>